module.exports = __webpack_public_path__ + "static/media/icon_12.e1aef29b.svg";